import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AuthModel } from "../../services/models";
import { useAuth } from "../../context/AuthContext";

export default function SessionExpiredModal({ isOpen }) {
  const navigate = useNavigate();
  const { toggleLogin } = useAuth();

  const handleLogin = () => {
    // Clear any remaining auth data
    AuthModel.logout();
    toggleLogin(false);
    // Navigate to login page
    navigate("/login");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing without login
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      size="md"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Session Expired</ModalHeader>
        <ModalBody>
          <VStack spacing={3} alignItems="flex-start">
            <Text>
              Your session has expired. Please log in again to continue.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={handleLogin}
            bgColor="black"
            color="white"
            borderRadius="lg"
            fontWeight="medium"
            py="6"
            px="7"
            w="full"
          >
            Go to Login
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

